(function () {
  "use strict";

  var drawer = document.querySelector("[data-product-upgrade-drawer]");
  if (!drawer) return;

  var contentEl = drawer.querySelector(".product-upgrade-slideout__content");
  var closeButtons = drawer.querySelectorAll("[data-upgrade-drawer-close]");
  var currentTrigger = null;
  var currentVariants = null;

  function getInputForTrigger(trigger) {
    var wrap = trigger.closest(".product-upsell__item-wrap");
    return wrap ? wrap.querySelector("[data-upsell-variant-input]") : null;
  }

  function open(trigger) {
    currentTrigger = trigger;
    var handle = trigger && trigger.getAttribute("data-product-handle");
      if (window.lenis) {
      window.lenis.stop();
    }
    if (!handle) return;
    drawer.style.display = "";
    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("open");
    document.body.style.overflow = "hidden";
    contentEl.innerHTML = "<div class=\"product-upgrade-drawer__loading\"><span class=\"product-upgrade-drawer__loading-dot\"></span><span class=\"product-upgrade-drawer__loading-dot\"></span><span class=\"product-upgrade-drawer__loading-dot\"></span></div>";
    fetch("/products/" + handle + "?section_id=product-upgrade-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var inner = doc.querySelector(".product-upgrade-drawer__inner");
        if (inner) {
          contentEl.innerHTML = "";
          contentEl.appendChild(inner);
          var variantsJson = inner.getAttribute("data-product-variants");
          if (variantsJson) {
            try {
              currentVariants = JSON.parse(variantsJson);
            } catch (e) {
              currentVariants = [];
            }
          }
          initVariantSelection(inner);
          initAddToCart(inner);
        } else {
          contentEl.innerHTML = "<p>Unable to load product.</p>";
        }
      })
      .catch(function () {
        contentEl.innerHTML = "<p>Unable to load product.</p>";
      });
  }

  function close() {
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    currentTrigger = null;
    currentVariants = null;
    if (window.lenis) {
      window.lenis.start();
    }
  }

  function findVariantByOptions(inner, options) {
    if (!currentVariants || !Array.isArray(currentVariants)) return null;
    return currentVariants.find(function (v) {
      if (!v.options || v.options.length !== options.length) return false;
      return options.every(function (opt, i) { return opt === v.options[i]; });
    });
  }

  function getSelectedOptions(inner) {
    var options = [];
    inner.querySelectorAll(".product-upgrade-drawer__fieldset").forEach(function (fieldset) {
      var radio = fieldset.querySelector("input[type=radio]:checked");
      options.push(radio ? radio.value : null);
    });
    return options;
  }

  function getSelectedOptionsFromInner(inner) {
    var options = [];
    inner.querySelectorAll(".product-upgrade-drawer__fieldset").forEach(function (fieldset) {
      var radio = fieldset.querySelector("input[type=radio]:checked");
      options.push(radio ? radio.value : null);
    });
    return options;
  }

  function updateUpgradeNoneButtonState(inner) {
    var wrapper = inner.querySelector("[data-upgrade-cant-decide-wrapper]");
    if (!wrapper) return;
    var btn = wrapper.querySelector("[data-upgrade-none-color-select]");
    if (!btn) return;
    var colorIndex = parseInt(wrapper.getAttribute("data-upgrade-color-option-index"), 10);
    if (isNaN(colorIndex)) return;
    var noneValue = wrapper.getAttribute("data-upgrade-none-value") || "None";
    var options = getSelectedOptionsFromInner(inner);
    var isNone = options[colorIndex] === noneValue;
    btn.classList.toggle("is-checked", isNone);
    btn.setAttribute("aria-pressed", isNone ? "true" : "false");
  }

  function initCantDecideButtons(inner) {
    var wrapper = inner.querySelector("[data-upgrade-cant-decide-wrapper]");
    if (!wrapper) return;
    var noneSelectBtn = wrapper.querySelector("[data-upgrade-none-color-select]");
    if (!noneSelectBtn) return;
    noneSelectBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var input = inner.querySelector("input[data-upgrade-none-color-input]");
      if (input && input.classList.contains("product-upgrade-drawer__input")) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
    updateUpgradeNoneButtonState(inner);
  }

  function initVariantSelection(inner) {
    var variantIdInput = inner.querySelector("[data-upgrade-variant-id]");
    var variantImage = inner.querySelector("[data-upgrade-variant-image]");
    var currentPriceEl = inner.querySelector("[data-upgrade-current-price]");
    var comparePriceEl = inner.querySelector("[data-upgrade-compare-price]");
    var btnPriceEl = inner.querySelector("[data-upgrade-btn-price]");
    var radios = inner.querySelectorAll(".product-upgrade-drawer__input");

    function updateLegends(container) {
      if (!container) return;
      container.querySelectorAll(".product-upgrade-drawer__fieldset").forEach(function (fieldset) {
        var legend = fieldset.querySelector(".product-upgrade-drawer__legend");
        var optionName = fieldset.getAttribute("data-option-name");
        var checked = fieldset.querySelector("input[type=radio]:checked");
        if (legend && optionName) legend.textContent = optionName + (checked ? ": " + checked.value : "");
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (variant.featured_image && variantImage) {
        variantImage.src = variant.featured_image.src.split("?")[0] + "?width=1024";
        variantImage.alt = variant.featured_image.alt || "";
      }
      var moneyFormat = window.money_without_trailing_zeros_format || window.money_format;
      var formatMoney = window.Shopify && typeof window.Shopify.formatMoney === "function"
        ? function (c) { return window.Shopify.formatMoney(c, moneyFormat); }
        : function (c) { return "$" + (c / 100).toFixed(2).replace(/\.?0+$/, ""); };
      if (currentPriceEl) currentPriceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = "";
        } else {
          comparePriceEl.style.display = "none";
        }
      }
      if (btnPriceEl) btnPriceEl.textContent = formatMoney(variant.price);
      var addBtn = inner.querySelector("[data-upgrade-add-to-cart]");
      if (addBtn) {
        addBtn.dataset.variantId = variant.id;
        addBtn.disabled = !variant.available;
      }
      updateLegends(inner);
    }

    radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        var options = getSelectedOptions(inner);
        var variant = findVariantByOptions(inner, options);
        updateForVariant(variant);
        var fieldset = radio.closest(".product-upgrade-drawer__fieldset");
        if (fieldset) {
          fieldset.querySelectorAll(".product-upgrade-drawer__swatch, .product-upgrade-drawer__option-label").forEach(function (l) { l.classList.remove("selected"); });
        }
        var label = inner.querySelector("label[for=\"" + radio.id + "\"]");
        if (label) label.classList.add("selected");
        updateUpgradeNoneButtonState(inner);
      });
    });

    var initialVariant = inner.querySelector("[data-upgrade-variant-id]");
    if (initialVariant && currentVariants) {
      var vid = parseInt(initialVariant.value, 10);
      var v = currentVariants.find(function (x) { return x.id === vid; });
      if (v) updateForVariant(v);
    }
    initCantDecideButtons(inner);
  }

  function initAddToCart(inner) {
    var addBtn = inner.querySelector("[data-upgrade-add-to-cart]");
    if (!addBtn) return;
    addBtn.addEventListener("click", function () {
      var variantId = addBtn.getAttribute("data-variant-id");
      if (!variantId || addBtn.disabled) return;
      var triggerToMark = currentTrigger;
      var inputEl = triggerToMark ? getInputForTrigger(triggerToMark) : null;
      if (inputEl) {
        inputEl.value = variantId;
        inputEl.setAttribute("data-has-value", "true");
      }
      close();
      if (triggerToMark) triggerToMark.classList.add("added");
    });
  }

  closeButtons.forEach(function (btn) {
    btn.addEventListener("click", close);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("open")) close();
  });

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-upgrade-drawer-trigger]");
    if (!trigger) return;
    e.preventDefault();
    var inputEl = getInputForTrigger(trigger);
    var hasValue = inputEl && inputEl.getAttribute("data-has-value") === "true";
    if (hasValue) {
      if (inputEl) {
        inputEl.value = "";
        inputEl.setAttribute("data-has-value", "false");
      }
      trigger.classList.remove("added");
      return;
    }
    open(trigger);
  });
})();
